// extracted by mini-css-extract-plugin
module.exports = {"ArrowLeft":"ArrowLeft_ArrowLeft__2Csjy","ArrowUp":"ArrowLeft_ArrowUp__1o8FS","ArrowDown":"ArrowLeft_ArrowDown__2pxPe"};